import { defineComponent, onMounted } from 'vue';
import { useStore } from 'vuex';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './plugins/firebase';
export default defineComponent({
    name: 'App',
    setup() {
        const store = useStore();
        onMounted(() => {
            onAuthStateChanged(auth, (user) => {
                store.dispatch('setUser', user);
            });
        });
        return {};
    },
});
